export default "__VITE_ASSET__ksGyEU3Y__"